module.exports = __webpack_public_path__ + "img/eagleWingsLogo@1x.7d06825d.png";